import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuardFn } from '@auth0/auth0-angular';
import { referralSignupGuard, referralStatusGuard } from 'shared/services/guards/referral-signup.guard';
import { SignupFormComponent, SignupFormModule } from './components/signup-form';
import { SignupSentComponent } from './components/signup-form/components/signup-sent/signup-sent.component';
import { ReferralSignupComponent, ReferralSignupModule } from './referral';
import { SignupReferralStatusComponent } from './referral/referral-status/referral-status.component';
import { StartReferralSignupComponent } from './referral/start-referral/start-referral/start-referral.component';
import { SignupRequestComponent, SignupRequestModule } from './signup-request';
import { SignupVerifyEmailComponent } from './components/verify-email/verify-email.component';
import { SignupVerifiedEmailComponent } from './components/verified-email/verified-email.component';
import { SignupErrorComponent } from './components/signup-error/signup-error.component';
import { signupGuard, verifyEmailGuard } from 'shared/services/guards/signup-guard.service';
import { SignupFinishComponent } from './components/signup-finish/signup-finish.component';
import { SignupInviteComponent } from './invite/invite.component';

const routes: Routes = [
    {
        path: 'signup',
        children: [
            {
                path: 'invite',
                children: [
                    {
                        path: ':token',
                        component: SignupInviteComponent
                    }
                ]
            },
            {
                path: 'finish/:requestId',
                canActivate: [authGuardFn],
                component: SignupFinishComponent
            },
            {
                path: '',
                canActivate: [signupGuard],
                component: SignupRequestComponent,
                children: [
                    {
                        path: '',
                        component: SignupFormComponent
                    },
                    {
                        path: 'verify-email',
                        canActivate: [verifyEmailGuard],
                        component: SignupVerifyEmailComponent
                    },
                    {
                        path: 'error',
                        component: SignupErrorComponent
                    }
                ]
            },
            {
                path: 'verified-email',
                canActivate: [authGuardFn],
                component: SignupVerifiedEmailComponent
            },
            {
                path: 'referral',
                children: [
                    {
                        path: 'join',
                        canActivate: [referralStatusGuard, referralSignupGuard],
                        component: ReferralSignupComponent,
                        children: [
                            {
                                path: '',
                                component: SignupFormComponent
                            }
                        ]
                    },
                    {
                        path: ':referralId',
                        children: [
                            {
                                path: '',
                                component: ReferralSignupComponent,
                                children: [
                                    {
                                        path: '',
                                        canActivate: [referralStatusGuard],
                                        component: StartReferralSignupComponent
                                    },
                                    {
                                        path: 'status/:statusCode',
                                        component: SignupReferralStatusComponent
                                    },
                                    {
                                        path: 'verify-email',
                                        canActivate: [verifyEmailGuard],
                                        component: SignupVerifyEmailComponent
                                    },
                                    {
                                        path: 'thank-you',
                                        component: SignupSentComponent
                                    },
                                    {
                                        path: 'error',
                                        component: SignupErrorComponent
                                    }
                                ]
                            },
                            {
                                path: 'finish/:requestId',
                                canActivate: [referralStatusGuard, referralSignupGuard],
                                component: SignupFinishComponent
                            }
                        ]
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes), SignupRequestModule, ReferralSignupModule, SignupFormModule],
    exports: [RouterModule]
})
export class SignupRoutingModule {}
